function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15.013"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2496",
  "data-name": "Path 2496",
  d: "M11.774 0L7.5 4.272 3.228.013 0 3.239l4.274 4.274L0 11.785l3.228 3.228L7.5 10.739l4.272 4.275L15 11.785 10.73 7.5 15 3.225z",
  fill: "#fff"
})));